import { Component, Inject, OnInit } from '@angular/core';
import { CustomIconService } from 'src/app/core/services/custom-icon.service';
import { UserService } from '../../../../../../../core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlowsService } from 'src/app/contexts/snapshot/flows.service';

@Component({
  selector: 'app-flow-confirm-edit-modal',
  templateUrl: './flow-confirm-edit-modal.component.html',
  styleUrls: ['./flow-confirm-edit-modal.component.scss'],
})
export class FlowConfirmEditModal implements OnInit {
  model: any = {};

  constructor(
    private dialogRef: MatDialogRef<FlowConfirmEditModal>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private customIconService: CustomIconService,
    private toastr: ToastrService,
    private flowService: FlowsService,
    public router: Router,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.model.partner = this.data.partner;
    this.model.account = this.data.account;
    this.model.user = this.userService.user;
    this.model.flow_id = this.data.flow_id;
    this.model.version = this.data.version;
    this.model.snapshot_id = this.data.snapshot_id;
    this.model.selector_test_id = this.data.selector_test_id;
    this.customIconService.init();
  }

  confirmEdit() {

    var params = {
      snapshot_id: this.model.snapshot_id,
      selector_test_id: this.model.selector_test_id,
      flow_id: this.model.flow_id,
      version: this.model.version
    };



    this.flowService.createNewVersion(this.model.partner, this.model.account, params)
      .subscribe(
        {
          next: (response) => {

            var period = {
              start: null,
              end: moment().format('YYYY-MM-DD')
            };



            this.dialogRef.close(response);


          },
          error: (error) => {
            if (error.result.length > 0) {
              error.result.forEach(element => {
                this.toastr.error(element.message);
              });
            }
          }
        }
      );

  }

  close() {
    this.dialogRef.close();
  }

}

